import React from 'react';
import { Dialog, Flex, IconButton, Tooltip } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { DeleteIcon, InfoIcon } from 'shared/icons';
import { SavedJob } from './types';
import { SavedJobConfirmDialog } from './saved-job-confirm-dialog';
import { useSavedJobs } from './saved-jobs.provider';

const SavedJobActionsMenuView = ({ savedJob }: { savedJob: SavedJob }) => {
   const [t] = useTranslation('global');
   const savedJobs = useSavedJobs();
   const [open, setOpen] = React.useState<boolean>(false);

   return (
      <Flex className="saved-jobs-actions-menu" gap="2" align="center" justify="center">
         <Tooltip content={t('jobseekerSavedJobs.action')} side="top">
            <IconButton
               color="blue"
               size="2"
               className="action-trigger"
               highContrast
               onClick={() => {
                  savedJobs.openJobDescription(savedJob);
               }}
            >
               <InfoIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Tooltip content={t('jobseekerSavedJobs.confirmTitle')} side="top">
            <IconButton
               color="red"
               size="2"
               className="action-trigger"
               onClick={() => {
                  setOpen(true);
               }}
            >
               <DeleteIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Dialog.Root
            open={open}
            onOpenChange={(isOpened) => {
               setOpen(isOpened);
            }}
         >
            <Dialog.Content aria-describedby={undefined} onOpenAutoFocus={(e) => e.preventDefault()}>
               <SavedJobConfirmDialog
                  title={t('jobseekerSavedJobs.confirmTitle')}
                  message={t('jobseekerSavedJobs.confirmTxt')}
                  confirmLabel={t('jobseekerSavedJobs.yes')}
                  cancelLabel={t('jobseekerSavedJobs.no')}
                  loading={
                     savedJobs.deleteSavedJobState.status === 'pending' &&
                     savedJobs.deletingShortListId === savedJob.short_lists_id
                  }
                  onConfirm={() => {
                     savedJobs.deleteSavedJob({
                        shortListId: savedJob.short_lists_id,
                        onSuccess: () => {
                           setOpen(false);
                           toast.success(t('jobseekerSavedJobs.successTxt'));
                        },
                        onError: (message) => {
                           toast.error(message || t('jobseekerSavedJobs.failedTxt'));
                        },
                     });
                  }}
               />
            </Dialog.Content>
         </Dialog.Root>
      </Flex>
   );
};

export const SavedJobActionsMenu = observer(SavedJobActionsMenuView);
